var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.Mobile)?_c('Home'):_vm._e(),(!_vm.Mobile)?_c('Mobile'):_vm._e(),_c('button',{staticClass:"but",on:{"click":function($event){return _vm.tet()}}},[_vm._v("PC模式")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }